// src/api/auth.js
const BASE_URL = 'https://api.ddhyaan.com/api';

export async function sendOtp(email) {
  const res = await fetch(`${BASE_URL}/login/send-otp/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email })
  });
  if (!res.ok) throw new Error('Failed to send OTP');
}

export async function verifyOtp(email, otp) {
  const res = await fetch(`${BASE_URL}/login/verify-otp/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, otp })
  });
  if (!res.ok) throw new Error('Invalid OTP');
  const data = await res.json();
  // Use access_token from response
  localStorage.setItem('token', data.access_token);
  return data.access_token;
}
